import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Problem } from '../components/sections/Problem';
import { Solution } from '../components/sections/Solution';
import { NicheFocus } from '../components/sections/NicheFocus';
import { HowItWorks } from '../components/sections/HowItWorks';
import { SupplierDirectory } from '../components/sections/SupplierDirectory';
import { SupplierBuildStrategy } from '../components/sections/SupplierBuildStrategy';
import { BuyerIntakeForm } from '../components/sections/BuyerIntakeForm';
import { SupplierApplicationForm } from '../components/sections/SupplierApplicationForm';
import { Compliance } from '../components/sections/Compliance';
import { BusinessModel } from '../components/sections/BusinessModel';
import { RevenueModel } from '../components/sections/RevenueModel';
import { Founder } from '../components/sections/Founder';
import { FinalCTA } from '../components/sections/FinalCTA';
export function HomePage() {
  return <>
      <Hero data-id="element-765" />
      <Problem data-id="element-766" />
      <Solution data-id="element-767" />
      <NicheFocus data-id="element-768" />
      <HowItWorks data-id="element-769" />
      <SupplierDirectory data-id="element-770" />
      <SupplierBuildStrategy data-id="element-771" />
      <BuyerIntakeForm data-id="element-772" />
      <SupplierApplicationForm data-id="element-773" />
      <Compliance data-id="element-774" />
      <BusinessModel data-id="element-775" />
      <RevenueModel data-id="element-776" />
      <Founder data-id="element-777" />
      <FinalCTA data-id="element-778" />
    </>;
}